export default {
  title: 'Histovery | Dashboard',
  dashboard_access: 'Accès au dashboard',
  navbar: {
    tab: {
      tabs: 'Mes onglets',
      dashboard: 'Dashboard',
      dashboards: 'Mes dashboards',
      uses: 'Usages',
      exploitation: 'Exploitation',
      download: 'Télécharger',
      admin: 'Admin',
      session: 'Session',
    },
  },
  legend: 'Légende',
  sign_in: 'Se connecter',
  sign_in_google: 'Se connecter avec Google',
  logging_in: 'Connexion en cours...',
  sign_out: 'Se déconnecter',
  unsubscribe: 'Me désinscrire',
  users: 'Utilisateurs',
  select_users: 'Sélectionner un/des utilisateur(s)',
  email: 'Email',
  emails: 'Emails',
  password: 'Mot de passe',
  password_confirmation: 'Confirmer le mot de passe',
  comments: 'Commentaires',
  bookmarks: 'Favoris',
  'bookmarks.mine': 'Mes favoris',
  'bookmarks.others': 'Les autres',
  comments_found: 'commentaires trouvés',
  display_literacy: 'Afficher la lisibilité',
  my_favourites: 'Mes favoris',
  shared_with_me: 'Partagés avec moi',
  score_null: "Ce commentaire n'à pas été analysé pour le moment.",
  survey: 'Enquêtes',
  the: 'le',
  in: 'à',
  at: 'au',
  level: 'Niveau',
  comments_lists: {
    title: 'Listes de commentaires',
    create_new_list: 'Créer une nouvelle liste',
    comments_number: 'Nombre de commentaires',
    litteracy: 'Qualité (commentaires)',
    visit: 'Visite',
    configurate_lists: 'Configurer les listes',
    quality: 'Qualité',
  },
  admin: {
    user: {
      create: 'Utilisateur {0} créé avec succès!',
      update: 'Utilisateur {0} mis à jour',
      delete: 'Utilisateur {0} supprimé',
    },
    site: {
      create: 'Site {0} créé avec succès!',
      update: 'Site {0} mis à jour',
      delete: 'Site {0} supprimé',
    },
  },
  modal: {
    title_creation_chart: "Création d'un nouveau graph",
    title_config_chart: 'Configuration du graph {0}',
    tab_data_header: 'Sélectionner les données à étudier',
    tab_options_header: "Options d'affichage",
    new_request_infos: 'Réquêtera de nouvelles données si modifié',
    display_mode: "Mode d'affichage",
    display_grid: 'Quadrillage',
    display_weekend: 'Week-end',
    stacked: 'Empilé',
    zoom: 'Zoom',
    chart_type: 'Type de graphique',
    data_type: 'En...',
    in: 'En',
    data_value: 'Je veux voir les',
    type_of_data: 'Type de données',
    filters: 'Filtres',
    distribution_type: 'Réparti par',
    title: 'Titre',
    title_fr: 'Titre français',
    title_en: 'Titre anglais',
    xTitle: 'Titre abscisse',
    yTitle: 'Titre ordonnées',
    dashboard_title: 'Titre du dashboard',
    tab_title: "Titre de l'onglet",
    confirm_chart_delete: 'Êtes vous sûr de vouloir supprimer ce graph ?',
    share_dashboard: 'Partager le dashboard "{0}"',
    share_tab: 'Share l\'onglet tab "{0}"',
    share_comment: 'Partager un commentaire',
    confirm_dashboard_delete: 'Êtes vous sûr de vouloir supprimer ce dashboard "{0}" ?',
    confirm_tab_delete: 'Êtes vous sûr de vouloir supprimer cet onglet "{0}" ?',
    confirm_user_delete: 'Êtes vous sûr de vouloir supprimer cet utilisateur : {0} ?',
    confirm_site_delete: 'Êtes vous sûr de vouloir supprimer ce site : {0} ?',
    confirm_sending_mail:
      "Êtes vous sûr de vouloir d'envoyer de nouveau le mail after visit à cet utilisateur : {0} ?",
  },
  display_options_title: "Options d'affichage",
  display_options: {
    expanded: 'Étendu',
    compact: 'Compact',
    none: 'Non',
  },
  settings: 'Paramètres',
  add: 'Ajouter',
  add_chart: 'Ajouter un graph',
  filters: 'Filtres',
  add_filters: 'Ajouter des filtres',
  preconfig: 'Pré-configurer des filtres ?',
  create: 'Créer',
  delete: 'Supprimer',
  share: 'Partager',
  edit: 'Editer',
  copy: 'Copie',
  duplicate: 'Dupliquer',
  role: 'Rôle',
  auth_type: 'Type de compte',
  validate: 'Valider',
  save: 'Sauvegarder',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  sort: {
    by_date_desc: 'Date décroissante',
    by_date_asc: 'Date croissante',
    by_rating_desc: 'Note décroissante',
    by_rating_asc: 'Note croissante',
    by_score_desc: 'Score décroissante',
    by_score_asc: 'Score croissante',
    by_device_serial_desc: 'Serial décroissant',
    by_device_serial_asc: 'Serial croissant',
    by_site_id_desc: 'Site décroissant',
    by_site_id_asc: 'Site croissant',
    by_value_desc: 'Valeur décroissante',
    by_value_asc: 'Valeur croissante',
    by_alpha_desc: 'Alpha décroissante',
    by_alpha_asc: 'Alpha croissante',
    none: 'Aucun',
  },
  sort_by: 'Trier par',
  view_by: 'Afficher par',
  display_by: 'Afficher par',
  suggestion: 'Suggestion',
  select_all: 'Tous',
  sites: 'Sites',
  'site.title': 'Site',
  'site.site_location': 'Site location',
  'site.edit': 'Editer un site',
  'site.add': 'Ajouter un site',
  'site.name': 'Nom du site',
  'site.name_placeholder': 'Nom du nouveau site',
  'site.site_id': 'ID du site',
  'site.site_id_placeholder': 'ID du site',
  'site.launch_date': 'Date de lancement',
  'site.end_date': 'Date de fin',
  'site.status': 'Statut',
  'site.status.active': 'Actif',
  'site.status.inactive': 'Inactif',
  'site.log_version': 'Version de log du site',
  'site.has_survey': 'Survey intégrée ?',
  'site.has_map': 'Plans intégrés ?',
  'site.default_level': 'Niveau par défaut',
  'site.levels': 'Niveaux du site',
  'site.url_placeholder': 'Ajouter un hostname authorisé',
  'site.products': 'Produits',
  'site.languages': 'Langues',
  'site.total_treasure_count': 'Nombre total de trésors',
  comment: 'Commentaire',
  add_comment: 'Ajouter le commentaire à',
  select_list: 'Sélectionner la/les listes',
  create_list: 'Créer une nouvelle liste',
  add_and_create: 'Créer et ajouter',
  added_new_list_comment_confirmation: 'Commentaire ajouté dans la liste "{0}" !',
  added_comment_confirmation: 'Commentaire ajouté !',
  shared_comment_confirmation: 'Commentaire partagé !',
  add_comment_error: "Une erreur est survenue pendant l'ajout du commentaire, veuillez réessayer",
  delete_dashboard_warning: 'Impossible de supprimer votre dernier dashboard.',
  lists: 'Listes',
  list: 'Liste',
  download: {
    sessions: 'Télécharger les logs',
    session: 'Télécharger le fichier de log',
    comments: 'Télécharger les commentaires',
    survey: "Télécharger les réponses de l'enquête",
    chart_config: 'Télécharger la configuration du graphique au format JSON',
    map_data: 'Télécharger les données de parcours',
    contents: 'Télécharger le best-of des contenus',
    comment_email:
      "Il y a trop de commentaires sur la période sélectionnée. Un fichier Excel contenant les réponses de l'enquête sera envoyé à votre adresse email: {0}",

    survey_email:
      "Il y a trop de réponses à l'enquête sur la période sélectionnée. Un fichier Excel contenant les réponses de l'enquête sera envoyé à votre adresse email: {0}",
    logs_email:
      'Il y a trop de logs à récupérer sur la période sélectionnée. Un lien Google Cloud Storage vers un fichier ZIP contenant les logs sera envoyé à votre adresse email: {0}',
    logs_confirmation: 'Etes vous sur de voulour télécharger tous les logs sélectionnés ?',
    logs_confirmation_infos:
      'Vous êtes sur le point de télécharger <strong>{0}</strong> logs, ce qui prendra du temps et générera des dépenses pour la requête Google BigQuery associée. Vous pouvez confirmer votre requête en cliquant sur confirmer.',
  },
  upload_chart_config: 'Uploader une configuration de graphique',
  date: 'Date',
  visiting_time: 'Heure de visite',
  rating: 'Note',
  start: 'Début de visite',
  end: 'Fin de visite',
  upload: 'Upload',
  others: 'Autres',
  on: 'Sur',
  for: 'pour',
  affluence: 'Affluence',
  used_tablets: 'tablettes utilisées',
  used_tablet: 'tablette utilisée',
  survey_respondents: 'des répondants',
  survey_infos:
    '<strong>{0}</strong> réponses sur <strong>{1}</strong> visites, soit <strong>{2} %</strong> des visites',
  type: 'Type',
  value: 'Valeur',
  category: 'Catégorie',
  session: {
    id: 'Session n°',
    time: 'Heure de visite',
    site: 'Session du site',
    duration: 'Temps de visite',
    viewed_immersives: 'Immersives consultés',
    viewed_va: 'VA consultées',
    clicked_hotspots: 'Hotspots cliqués',
    opened_cartels: 'Cartels ouverts',
    viewed_io: 'IO consultés',
  },
  send: 'Envoyé ?',
  'send.time': "Heure d'envoi",
  open: 'Ouvert ?',
  'open.time': "Heure d'ouverture",
  database: 'Dans la base de données ?',
  yes: 'Oui',
  no: 'Non',
  by: 'par',
  'confirm.send':
    'Le mail after visit a bien été généré ! Il devrait être envoyer au destinataire dans les minutes qui suivent...',
  'failure.send':
    'Un problème est survenu pendant la génération du mail after visit. Veuillez réessayer.',
  display: 'Afficher',
  support: {
    email: 'Support email',
    send_confirmation: 'Tous les emails after visit ont été envoyés à cette adresse email: {0}',
    email_found_html:
      'Nous avons trouvé <strong>{0}</strong> visites avec cette adresse email : <strong>{1}</strong>. Voulez-vous renvoyer tous les emails after visit correspondants ?',
    email_found:
      'Nous avons trouvé {0} visites avec cette adresse email : {1}. Voulez-vous renvoyer tous les emails after visit correspondants ?',
    no_email_found: 'Aucune visite correpondante à cette adresse email: ',
    send_error: "Une erreur est survenue pendant l'envoi des emails after visit : {0}",
  },
  content: {
    bestof: 'Best of des contenus',
    name: 'Nom',
    total: "Total d'ouvertures/clics",
    sessions_rate: "Taux d'utilisation sur le total des sessions",
    uses_rate: "Taux d'utilisation sur le total des usages",
    indicator: '<strong>{0}</strong> interactions pour <strong>{1}</strong> visites',
  },
  batteries: 'Batteries',
  battery: {
    level: 'Niveau de batterie',
    levels: 'Niveaux des batteries',
    informations: 'Batteries des tablettes',
    gradients: 'Évolution des gradients de batteries',
    gradient: 'Répartition des gradients des niveaux de batteries',
    temperature: 'Température de la batterie',
    temperatures: 'Températures des batteries',
    last: 'Répartition des niveaux de batteries à la fin des visites',
    subtitle: '{0} sessions le {1}',
    infos_levels: 'Niveaux des batteries par session ({0} sessions)',
    infos_temperatures: 'Temperatures des batteries par session ({0} sessions)',
    infos_level_points: 'Niveaux des batteries par session ({0} sessions)',
    infos_temperature_points: 'Temperatures des batteries par session ({0} sessions)',
    infos_gradients_distribution: 'Répartition sur {0} sessions',
    time: 'Temps (minute)',
    infos: 'Informations sur les',
    zoom: 'Zoom',
    grid: 'Grille',
    crashes: 'Crashs',
    over_day: 'Sur la journée',
    status: 'État',
    medium: 'Moyen',
    bad: 'Mauvais',
    very_bad: 'Très mauvais',
    good: 'Bon',
  },
  device: 'Tablette n°',
  serial: 'Serial',
  device_placeholder: 'Serial des tablettes',
  device_sessions: 'Sessions et tablettes',
  sessions_found: 'sessions trouvées',
  site_id: {
    '1': 'Chateau de Chambord',
    '2': 'Musée Grévin',
    '3': 'Musée chinois de Fontainebleau',
    '4': 'La Conciergerie',
    '5': "Imagerie d'Epinal",
    '6': 'Palais des Papes',
    '7': 'Airborne Museum',
    '8': 'Château royal de Blois',
    '9': 'Pic du Midi',
    '10': 'Donjon de Loches',
    '11': "Château royal d'Amboise",
    '12': 'Forteresse royale de Chinon',
    '13': 'National museum of US Air Force',
    '14': 'Abbaye Notre-Dame de Sénanque',
    '15': 'Paris City Vision',
    '17': 'Saline Royale',
    '18': 'Albrechtsburg',
    '19': 'Moritzburg',
    '20': 'Expérience Notre-Dame',
    '21': 'ASOM',
    '22': 'Notre-Dame - Bernardins',
    '23': 'Notre-Dame - Washington',
    '24': 'Notre-Dame - Dresde',
  },
  site: {
    'france.chambord.chateau': 'Chateau de Chambord',
    'france.paris.grevin': 'Musée Grévin',
    'france.fontainebleau.musee-chinois': 'Musée chinois de Fontainebleau',
    'france.paris.conciergerie': 'La Conciergerie',
    'france.epinal.imagerie': "Imagerie d'Epinal",
    'france.avignon.palais-des-papes': 'Palais des Papes',
    'france.sainte-mere-eglise.airborne-museum': 'Airborne Museum',
    'france.blois.chateau': 'Château royal de Blois',
    'france.la-mongie.pic-du-midi': 'Pic du Midi',
    'france.loches.donjon': 'Donjon de Loches',
    'france.amboise.chateau': "Château royal d'Amboise",
    'france.chinon.forteresse': 'Forteresse royale de Chinon',
    'usa.dayton.usaf': 'National museum of US Air Force',
    'france.gordes.senanque': 'Abbaye Notre-Dame de Sénanque',
    'france.paris.pcv': 'Paris City Vision',
    'france.arcetsenans.saline': 'Saline Royale',
    'deutschland.meissen.albrechtsburg': 'Albrechtsburg',
    'deutschland.moritzburg.schlossmoritzburg': 'Moritzburg',
    'france.paris.notredame': 'Expérience Notre-Dame - Dubai',
    'usa.fayetteville.asom': 'ASOM',
    'france.paris.notredame.bernardins': 'Notre-Dame - Bernardins',
    'usa.washington.notredame': 'Notre-Dame - Washington',
    'deutschland.dresde.notredame': 'Notre-Dame - Dresde',
    'france.bormes-les-mimosas.mhab': 'MHAB',
    'usa.new-orleans.hnoc.notredame.expo': 'Notre-Dame - HNOC',
    'china.shanghai.notredame': 'Notre-Dame - Shangai',
    'france.paris.conciergerie.expogastronomie': 'Conciergerie - Expo Gastronomie',
    'notredame.totemexpo': 'Notre-Dame - Totem',
    'meissen.totemexpo': 'Meissen - Totem',
    'mhab.totemexpo': 'MHAB - Totem',
    'deutschland.berlin.mdf.notredame.expo': 'Notre-Dame - Berlin',
    'mexico.mexicocity.notredame.museofranzmayer': 'Notre-Dame - Mexico',
    'canada.montreal.notredame.arsenalcontemporaryart': 'Notre-Dame - Montréal Arsenal',
    'unitedkingdom.london.notredame.westminsterabbey': 'Notre-Dame - Westminster',
    'usa.washington.nmusa.expo-dday': 'DDay - NMUSA',
    'germany.colditz.schloss-colditz': 'Colditz',
    'spain.madrid.centrocentro.notredame': 'Notre-Dame - Madrid - CentroCentro',
    'korea.seoul.nationalpalacemuseumofkorea.notredame': 'Notre-Dame - Séoul',
    'france.wizernes.coupole': 'La Coupole',
    'brazil.saopaulo.museudaimagemedosom.notredame': 'Notre-Dame - Sao Paulo - MIS',
    'usa.sanantonio.missionalamo': 'Mission Alamo',
  },
  site_location: {
    'france.chambord.chateau': 'Chateau de Chambord',
    'france.paris.grevin': 'Musée Grévin',
    'france.fontainebleau.musee-chinois': 'Musée chinois de Fontainebleau',
    'france.paris.conciergerie': 'La Conciergerie',
    'france.epinal.imagerie': "Imagerie d'Epinal",
    'france.avignon.palais-des-papes': 'Palais des Papes',
    'france.sainte-mere-eglise.airborne-museum': 'Airborne Museum',
    'france.blois.chateau': 'Château royal de Blois',
    'france.la-mongie.pic-du-midi': 'Pic du Midi',
    'france.loches.donjon': 'Donjon de Loches',
    'france.amboise.chateau': "Château royal d'Amboise",
    'france.chinon.forteresse': 'Forteresse royale de Chinon',
    'usa.dayton.usaf': 'National museum of US Air Force',
    'france.gordes.senanque': 'Abbaye Notre-Dame de Sénanque',
    'france.paris.pcv': 'Paris City Vision',
    'france.arcetsenans.saline': 'Saline Royale',
    'deutschland.meissen.albrechtsburg': 'Albrechtsburg',
    'deutschland.moritzburg.schlossmoritzburg': 'Moritzburg',
    'france.paris.notredame': 'Expérience Notre-Dame',
    'usa.fayetteville.asom': 'ASOM',
    'france.paris.notredame.bernardins': 'Notre-Dame - Bernardins',
    'usa.washington.notredame': 'Notre-Dame - Washington',
    'deutschland.dresde.notredame': 'Notre-Dame - Dresde',
    'france.bormes-les-mimosas.mhab': 'MHAB',
    'usa.new-orleans.hnoc.notredame.expo': 'Notre-Dame - HNOC',
    'china.shanghai.notredame': 'Notre-Dame - Shangai',
    'france.paris.conciergerie.expogastronomie': 'Conciergerie - Expo Gastronomie',
    'notredame.totemexpo': 'Notre-Dame - Totem',
    'meissen.totemexpo': 'Meissen - Totem',
    'mhab.totemexpo': 'MHAB - Totem',
    'deutschland.berlin.mdf.notredame.expo': 'Notre-Dame - Berlin',
    'mexico.mexicocity.notredame.museofranzmayer': 'Notre-Dame - Mexico',
    'canada.montreal.notredame.arsenalcontemporaryart': 'Notre-Dame - Montréal Arsenal',
    'unitedkingdom.london.notredame.westminsterabbey': 'Notre-Dame - Westminster',
    'usa.washington.nmusa.expo-dday': 'DDay - NMUSA',
    'germany.colditz.schloss-colditz': 'Colditz',
    'spain.madrid.centrocentro.notredame': 'Notre-Dame - Madrid - CentroCentro',
    'korea.seoul.nationalpalacemuseumofkorea.notredame': 'Notre-Dame - Séoul',
    'france.wizernes.coupole': 'La Coupole',
    'brazil.saopaulo.museudaimagemedosom.notredame': 'Notre-Dame - Sao Paulo - MIS',
    'usa.sanantonio.missionalamo': 'Mission Alamo',
  },
  state: {
    OK: 'OK',
    KO: 'KO',
    PENDING: 'En attente',
  },
  status: {
    ACTIVE: 'Actif',
    INACTIVE: 'Inactif',
  },
  timeline: {
    start: 'Début',
    end: 'Fin',
    from: 'Du',
    to: 'Au',
    last_weekend: 'Dernier week-end',
    last_week: '7 derniers jours',
    last_month: '30 derniers jours',
    last_year: '365 derniers jours',
    year: 'Année {0}',
    since_first_january: 'Depuis le 1er janvier',
    launch: 'Depuis le lancement',
    custom: 'Sélectionner',
    select_preset: 'Sélectionner un préréglage',
    preset: 'Préréglage',
  },
  login: {
    custom: 'Connexion personnalisée',
    please: 'Veuillez vous connecter',
    email: 'Adresse email',
    password: 'Mot de passe',
    remember_me: 'Se souvenir de moi',
    password_confirmation: 'Confirmer le mot de passe',
    or: 'Ou',
  },
  chart: {
    save_invalid:
      'Vous devez sélectionner un type de graphique et/ou valider/supprimer les filtres en cours...',
    save_battery_invalid:
      'Vous devez et pouvez sélectionner uniquement un site dans les filtres pour valider un graphique de niveaux de batteries.',
    form_invalid: "Veuillez remplir tous les champs du formulaire s'il vous plait",
    download_data:
      'Télécharger les données du graphique au format CSV ou exporter le graphique en image (PNG ou SVG)',
    over_period: 'Période du {0} au {1}',
    with_filters: 'avec les filtres',
    copy_info: 'Copier la configuration du graph',
    paste_info: 'Coller la configuration du graph',
    show_config: 'Paramètres du graphique',
    what_data: 'Quelle donnée ?',
    how_display: "Comment l'afficher ?",
    delete: 'Supprimer le graph',
    time: 'Au cours du temps',
    indicator: 'Indicateur',
    distribution: 'Répartition',
    pie: 'Camembert',
    bar: 'Histogramme',
    day: "Au cours d'une journée",
    rotation: 'Rotations des tablettes',
    battery: 'Niveaux des batteries',
    matrix: 'Heatmap',
    grid: 'Quadrillage',
    contains_filters: 'Ce graphe contient des filtres.',
    title_suggested: 'Suggéré',
    data_type: {
      count: 'Nombre',
      average_time: 'Temps moyen',
      average_count: 'Moyenne',
      distribution: 'Répartition',
      percentage: 'Pourcentage',
      max_time: 'Temps max',
      min_time: 'Temps min',
      session_count: 'Nombre de sessions',
      duration: 'Durée',
      passages_count: 'Nombre de passages',
      percentage_passages_count: 'Pourcentage de passages',
      percentage_sessions_count: 'Pourcentage de sessions',
      is_crash: 'Crashs',
      no_beacon_detected: 'Beacon non détecté',
      beacon_detected: 'Beacon détecté',
    },
    data_value: {
      visit: 'Visites',
      email: 'Emails',
      comment: 'Commentaires',
      collected_treasure_count: 'Trésors trouvés',
      histopad_rating: 'Notes Histopad',
      visit_rating: 'Notes de la visite',
      histomaton_file: 'HistoSelfie',
      affluence: "Pics d'affluence",
      is_crash: 'Crashs',
      upload: 'Upload de logs',
      uploaded_time: 'Number of first time uploaded logs',
      uploaded_count: "Nombre d'upload de sessions",
      duplicate: 'Visites dupliquées',
      hotspot: 'Hotspots',
      cartel: 'Cartels',
      immersive: 'Immersives',
      interactiveobject: 'Object interactifs (IO)',
      interactivebuilding: 'Bâtiments interactifs (IB)',
      interactivecharacter: 'Personnages interactifs (IC)',
      sequence: 'Séquences',
      augmentedvisit: 'Visites augmentées (VA)',
      language: 'Langue',
      satisfaction: 'Satisfaction',
      email_delivered: 'Emails envoyés',
      email_open: "Ouverture d'emails",
      email_click: 'Clics dans les emails',
      email_delivered_session: "Visites qui ont reçu l'email after visit",
      email_open_session: "Visites qui ont ouvert l'email after visit",
      email_click_session: "Visites qui ont cliqué dans l'email after visit",
      survey_answer: 'Réponses des questionnaires',
      rotation: 'Rotation des tablettes',
      route_duration: 'Parcours',
      inactivity_time: 'Inactivité',
      area_visit: 'Visite de salle',
      beacon: 'Beacon détecté',
      max_temperature: 'Température max',
      min_temperature: 'Température min',
      average_temperature: 'Température moyenne',
      max_level: 'Niveau max',
      min_level: 'Niveau min',
      average_level: 'Niveau moyen',
      max_memory_level: 'Mémoire utilisée max',
      min_memory_level: 'Mémoire utilisée min',
      average_memory_level: 'Mémoire utilisée moyenne',
      max_temperature_gradient: 'Pente max de température',
      min_level_gradient: 'Pente max de niveau de batterie',
      max_memory_level_gradient: 'Pente max de mémoire utilisée',
      scan: 'Scan',
      stuck_log: 'Logs bloqués',
    },
    data_group: {
      global: 'Global',
      email: 'Emails',
      use: 'Usages',
      technical: 'Techniques',
      battery: 'Batterie & mémoire',
    },
  },
  filter: {
    by: 'Filtrer par',
    all: 'Tous',
    total: 'Total',
    others: 'Autres',
    add_invalid: 'Vous devez sélectionner au moins un élément présent dans la liste',
    select_invalid: "Vous devez valider le filtre avant d'en ajouter un nouveau",
    site_id: 'Site',
    site_location: 'Site',
    language: 'Langue',
    product: 'Produit',
    histopad_rating: 'Note HistoPad',
    visit_rating: 'Note de la visite',
    collected_treasure_count: 'Trésors trouvés',
    version: 'Version',
    player_version: 'Version du player',
    operating_system: 'OS',
    os_name: "Nom d'OS",
    os_build: "Build d'OS",
    os_version: "Version d'OS",
    device_vendor: 'Fournisseur de tablettes',
    device_model: 'Modèle de tablettes',
    site: 'Site',
    bucket: 'Bucket',
    duration: 'Durée',
    device_name: 'Nombre de rotations par tablette',
    warning_type: 'Type de warnings',
    state: 'État',
    status: 'Statut du site',
    by_site: 'Site',
    by_language: 'Langue',
    by_rating: 'Filtrer par note',
    by_histopad_rating: 'Note HistoPad',
    by_product: 'Filtrer par produit',
    by_visit_rating: 'Note visite',
    by_bookmark: 'Filtrer les favoris',
    by_list: 'Liste',
    quality: 'Lisibilité',
    litteracy: {
      all: 'Tous',
      bad: 'Faible',
      good: 'Haute',
      average: 'Moyenne',
      medium: 'Moyenne',
    },
  },
  language: {
    English: 'Anglais',
    French: 'Français',
    German: 'Allemand',
    Spanish: 'Espagnol',
    Italian: 'Italien',
    Chinese: 'Chinois',
    Japanese: 'Japonais',
    Russian: 'Russe',
    Polish: 'Polonais',
    Dutch: 'Néerlandais',
    Korean: 'Coréen',
    Brazilian: 'Brésilien',
    Portuguese: 'Portugais',
    AmericanEnglish: 'Américain',
    'en-GB': 'Anglais',
    'fr-FR': 'Français',
    'fr-FALC': 'Français simplifié',
    'de-DE': 'Allemand',
    'es-ES': 'Espagnol',
    'it-IT': 'Italien',
    'zh-CN': 'Chinois',
    'ja-JP': 'Japonais',
    'ru-RU': 'Russe',
    'pl-PL': 'Polonais',
    'nl-NL': 'Néerlandais',
    'ko-KR': 'Coréen',
    'pt-BR': 'Brésilien',
    'pt-PT': 'Portugais',
    'en-US': 'Américain',
    'cs-CZ': 'Tchèque',
    'ar-AR': 'Arabe',
    'he-HE': 'Hebreux',
    'hu-HU': 'Hongrois',
    'oc-FR': 'Provençal',
    none: 'Non renseigné',
  },
  star: 'étoile',
  stars: 'étoiles',
  treasure: 'trésor',
  treasures: 'trésors',
  product: {
    Standard: 'Standard',
    PMR: 'PMR',
    Guide: 'Guide',
    Pro: 'Pro',
    Histopad45Mins: 'Mode 45 minutes',
    HistopadLSF: 'Mode sourds et malentendants',
    AudiopadReducedVision: 'AudioPad',
    '45Min': '45 minutes',
    Travaux: 'Travaux',
    VisuallyImpaired: 'Malvoyant',
    Deaf: 'Sourd',
    Audiodescription_FR: 'Audiodescription FR',
    Sightless: 'Aveugle',
    Comfort: 'Confort',
  },
  warning_type: {
    not_set: 'Pas encore défini',
    device_overheating: "Surchauffe de l'appareil",
    high_memory_usage: 'Utilisation élevée de la mémoire',
    low_battery: 'Batterie faible',
    no_beacon_detected: 'Aucun beacon détecté',
  },
  sidebar: {
    title_invalid: 'Vous devez saisir au moins un titre valide',
    filters_invalid:
      'Vous devez saisir au moins un titre valide et / ou valider tous les filtres sélectionnés',
  },
  dashboard: {
    create: 'Créer un nouveau dashboard',
    duplicate: 'Dupliquer le dashboard "{0}" ?',
    delete: 'Supprimer le dashboard',
    edit: 'Editer le dashboard',
    update: 'Éditer le titre du dashboard',
    add: 'Ajouter un nouveau dashboard à cet onglet',
    new_header: 'Ceci est un nouveau dashboard !',
    new_info_1: 'Mais il ne contient aucun graphique pour le moment.',
    new_info_2: 'Pour ajouter un graphique, cliquez sur le bouton ci-dessous :',
    form_title_invalid: 'Titre du dashboard manquant',
    form_invalid: 'Vous devez spécifier un titre et/ou valider/supprimer les filtres en cours',
  },
  tab: {
    create: 'Créer un nouvel onglet',
    form_invalid: 'Vous devez donner un titre à votre nouvel onglet',
    duplicate: 'Dupliquer l\'onglet "{0}"?',
    edit: "Éditer le titre de l'onglet",
    update: "Éditer le tire de l'onglet",
    delete: "Supprimer l'onglet",
    share: "Partager l'onglet",
  },
  user: {
    edit: 'Editer un utilisateur',
    add: 'Ajouter un utilisateur',
    admin: 'Administrateur',
    administrator: 'Administrateur',
    histovery: 'Histovery',
    partner: 'Partenaire',
    email_placeholder: 'Email du nouvel utilisateur',
    google: 'Google',
    custom: 'Personnalisé',
    password_mismatch: 'Les mots de passes ne concordent pas, veuillez réessayer.',
  },
  export: {
    what: 'Quoi ?',
  },
  unit: {
    no: '',
    minute: 'minutes',
    seconde: 'secondes',
    day: 'par jour',
    session: 'par visite',
    percent: '%',
    byte: 'Mb',
    degree: '°C',
    degree_per_minute: '°C / min',
    percent_per_minute: '% / min',
    byte_per_minute: 'Byte / min',
  },
  total: 'au total',
  search: {
    email: 'Rechercher un email',
    keyword: 'Rechercher un mot-clé',
    session: 'Rechercher une session',
  },
  message: {
    page_not_found:
      "Il semblerait que la page que vous avez demandé n'existe pas (ou pas encore)...",
    error: {
      wrong_login: 'Mauvais mot de passe / email',
      password_missing: 'Mot de passe manquant',
      email_missing: 'Email manquant',
      login:
        'Impossible de vous authentifier, veuillez vérifier votre email et votre mot de passe et réessayer',
      copy: 'Une erreur est survenue pendant la duplication, veuille réessayer',
      share: 'Une erreur est survenue pendant le partage, veuillez réessayer',
      unsubscription:
        'Une erreur est survenue pendant la désinscription de votre email, veuillez réessayer',
      data:
        'Une erreur est survenue pendant la récupération des données de ce graphiquer, veuillez réessayer en cliquant sur le bouton ci-contre',
    },
    infos: {
      dashboard_shared: 'Dashboard partagé avec succès !',
      tab_shared: 'Onglet partagé avec succès !',
      unsubscription: 'Votre email a bien été retiré de notre liste de diffusions !',
      unsubscription_header:
        'A bientôt ! Veuillez cliquer sur le bouton ci-dessous pour vous désinscrire :',
    },
  },
  footer: 'Dashboard version {0}',
  survey_answers: {
    Survey_PriceVisit_Very_Correct: 'Très correct',
    Survey_PriceVisit_Correct: 'Correct',
    Survey_PriceVisit_High: 'Élevé',
    Survey_WithWhom_Couple: 'en couple',
    Survey_WithWhom_Family: 'en famille',
    Survey_WithWhom_Friends: 'avec des ami(e)s',
    Survey_WithWhom_Other: 'autre',
    Survey_WithWhom_Group: 'en groupe organisé',
    Survey_WithWhom_Solo: 'en solo',
    Survey_FirstVisit_NoCameOnce: 'Non, je suis déjà venu une fois',
    Survey_FirstVisit_NoCameSeveralTimes: "Non, je suis déjà venu plus d'une fois",
    Yes: 'Oui',
    No: 'Non',
    Survey_HistoPadUserFriendly_YesIntuitive: "Tout à fait, c'est intuitif !",
    Survey_HistoPadUserFriendly_YesOk: 'Oui, ça va',
    Survey_Origin_ForeignCountry: 'Pays étranger',
    Survey_Origin_France: 'France',
    Survey_Reside_Answer_HautesPyrenees: 'Hautes-Pyrénées',
    Survey_Reside_Answer_HauteGaronne: 'Hautes-Garonne',
    Survey_Reside_Answer_PyreneesAtlantique: 'Pyrénées-Atlantique',
    Survey_Reside_Answer_Gers: 'Gers',
    Survey_Reside_Answer_Other: 'Autre',
    Survey_ResideHautesPyrenees_Answer_Campan: 'Vallée de Campan (La Mongie, Bagnères de Bigorre)',
    Survey_ResideHautesPyrenees_Answer_Gavarnie: 'Vallée de Gavarnie (Barèges, Luz, Gavarnie)',
    Survey_ResideHautesPyrenees_Answer_Gaves: 'Vallée des Gaves (Cauterets, Argelès, Val d’Azun)',
    Survey_ResideHautesPyrenees_Answer_AureLouron: 'Vallée d’Aure et du Louron (St Lary, Arreau)',
    Survey_ResideHautesPyrenees_Answer_Lourdes: 'Lourdes',
    Survey_ResideHautesPyrenees_Answer_Other: 'Ailleurs dans les Hautes-Pyrénées',
    Survey_ResideHauteGaronne_Answer_Luchon: 'Luchon',
    Survey_ResideHauteGaronne_Answer_Other: 'Ailleurs en Haute-Garonne',
    Survey_Income_Answer_LessThan1500: '– de 1500€',
    Survey_Income_Answer_1500To3000: '1500 à 3000€',
    Survey_Income_Answer_3000To4500: '3000 à 4500',
    Survey_Income_Answer_4500To6000: '4500 à 6000',
    Survey_Income_Answer_MoreThan6000: '6000€ et +',
    Survey_Income_Answer_NoAnswer: 'Ne souhaite pas répondre',
    Survey_Planetarium_Answer_Yes: 'Oui',
    Survey_Planetarium_Answer_No: 'Non',
    Survey_SeanceCoupole_Answer_Yes: 'Oui',
    Survey_SeanceCoupole_Answer_No: 'Non',
    Survey_HearAboutSite_WordMouth: 'Bouche à oreille',
    Survey_HearAboutSite_Report: 'Reportage (TV/Radio/Journal…)',
    Survey_HearAboutSite_Internet: 'Internet',
    Survey_HearAboutSite_Flyer: 'Dépliant',
    Survey_HearAboutSite_Advertisment: 'Publicité (Affichage/Radio/Réduction…)',
    Survey_HearAboutSite_Other: 'Autre',
    Survey_HearAboutExhibit_WordOfMouth: 'Bouche à oreille',
    Survey_HearAboutExhibit_Digital: 'Numérique (téléphone portable/en ligne)',
    Survey_HearAboutExhibit_Print: 'Presse (journal/magazine)',
    Survey_HearAboutExhibit_Radio: 'Radio',
    Survey_HearAboutExhibit_Television: 'Télévision',
    Survey_HearAboutExhibit_Other: 'Autre',
    Survey_HearAboutExhibit_Advertisment: 'Publicité',
    Survey_HearAboutExhibit_Report: 'Rapport',
    Survey_Gender_Male: 'Homme',
    Survey_Gender_Female: 'Femme',
    Television: 'Television',
    Radio: 'Radio',
    Survey_RentingPrice_JustRight: 'Juste',
    Survey_RentingPrice_TooLow: 'Trop faible',
    Survey_RentingPrice_TooHigh: 'Trop élevé',
    Others: 'Autres réponses',
    Survey_VisitPrice_VeryCorrect: 'Très correct',
    Survey_VisitPrice_Correct: 'Correct',
    Survey_VisitPrice_High: 'Élevé',
    Survey_WithWhom_GroupTwentyMore: 'en groupe (20 pers. et +)',
    Survey_Coming_WordMouth: 'Bouche à oreille',
    Survey_Coming_TravelGuide: 'Guides touristiques',
    Survey_Coming_CastleWebsite: 'Site internet du château',
    Survey_Coming_CastleFlyer: 'Brochure du château',
    Survey_Coming_CastleActivity: 'Activités proposées sur site',
    Survey_Coming_TouristOffice: 'Office du tourisme',
    Survey_Coming_AdvertDisplay: 'Affichage publicitaire',
    Survey_Coming_Media: 'Presse (TV, Radio, articles)',
    Survey_Transportation_Car: 'en voiture',
    Survey_Transportation_Bus: 'en autocar',
    Survey_Transportation_NavetteRemi: 'en bus-navette château Rémi',
    Survey_Transportation_Bicycle: 'en vélo',
    Survey_VisitPrice_Correct_Meissen: 'Correct',
    Survey_VisitPrice_High_Meissen: 'Elevé',
    Survey_HearAboutSite_WordMouth_Meissen: 'Bouche à oreille',
    Survey_HearAboutSite_Internet_Meissen1: 'Site internet schloesserland-sachsen.de',
    Survey_HearAboutSite_Internet_Meissen2: 'Site internet albrechtsburg-meissen.de',
    Survey_HearAboutSite_Internet_Moritzburg: 'Site internet schloss-moritzburg.de',
    Survey_OtherOffers_Event_Moritzburg: 'Événements au château de Moritzburg',
    Survey_OtherOffers_Moritzburg:
      "Visite d'autres installations de loisirs dans la région, par exemple le mémorial de Käthe Kollwitz ou le Fasanenschloss",
    Survey_HasImprovedVisit_YesGreat: 'Oui, beaucoup !',
    Survey_HasImprovedVisit_YesOk: 'Oui, sans plus',
    Survey_VisitPrice_Low: 'Trop bas',
    Survey_HearAboutSite_Internet_OtherWebsites: 'Autres sites internet',
    Survey_HearAboutSite_Instagram: 'Instagram',
    Survey_HearAboutSite_Facebook: 'Facebook',
    Survey_HearAboutSite_Magazines: 'Presse écrite',
    Survey_HearAboutSite_AdvertisementMeissen: 'Affiches publicitaires',
    Survey_HearAboutSite_Flyer2: 'Dépliants, brochures',
    Survey_HearAboutSite_TouristInformationsoffice: 'Office de tourisme',
    Survey_HearAboutSite_Hotel: 'Hébergement',
    Survey_HearAboutSite_Advertisement: 'Publicité (Affichage/Radio/Réduction…)',
    Survey_Age_Category1: 'Moins de 14 ans',
    Survey_Age_Category2: '14-19 ans',
    Survey_Age_Category3: '20-29 ans',
    Survey_Age_Category4: '30-39 ans',
    Survey_Age_Category5: '40-49 ans',
    Survey_Age_Category6: '50-59 ans',
    Survey_Age_Category7: '60-69 ans',
    Survey_Age_Category8: 'Plus de 70 ans',
    Survey_HasImprovedVisit_NoImprovement: 'Non, pas du tout',
    Survey_WillRecommend_Sure: 'Bien sûr!',
    Survey_WillRecommend_MostlySure: 'Certainement',
    Survey_WillRecommend_DontKnow: 'Je ne sais pas',
    Survey_WillRecommend_MaybeNot: 'Plutôt pas',
    Survey_WillRecommend_NotAtAll: 'En aucun cas',
    Survey_OtherOffers_Gastronomy: 'Gastronomie',
    Survey_OtherOffers_GuidedTour: 'Visite guidée',
    Survey_OtherOffers_Hiking: 'Randonnée dans les environs',
    Survey_OtherOffers_RentANightAround: 'Hébergement dans les environs',
    Survey_OtherOffers_Shopping: 'Shopping',
    Survey_OtherOffers_Others: 'Autres',
    Survey_VisitPrice_VeryHappy: 'Très satisfait',
    Survey_VisitPrice_Happy: 'Satisfait',
    Survey_VisitPrice_Good: 'Ça va',
  },
  survey_questions: {
    Survey_Rating_WelcomeAccessibility: 'Accueil et disponibilité du personnel',
    Survey_Rating_PracticalInformations: 'Informations pratiques',
    Survey_Rating_WaitingTime: "Temps d'attente",
    Survey_Rating_ComfortCleanliness: 'Confort et propreté',
    Survey_Choice_VisitPrice: 'Comment évaluez-vous le prix de la visite ?',
    Survey_HistoPadUserFriendly_Question: "L'HistoPad est-il facile à utiliser ?",
    Survey_OpenAnswer_WhatCanWeChange: 'Si non, que pouvons-nous améliorer ?',
    Survey_Age_Question: 'Quel âge avez-vous ?',
    Survey_Origin_Question: "D'où venez vous ?",
    Survey_Origin_Pays: "D'où venez-vous (pays étranger) ?",
    Survey_Origin_Departement: "D'où venez-vous (département) ?",
    Survey_Origin_France: "D'où venez-vous (France)?",
    Survey_FirstVisit_Question: 'Est-ce votre première visite ?',
    Survey_WithWhom_Question: 'Vous êtes venus...',
    Survey_Rating_Signalitique: 'Signalétique et information dans le site',
    Survey_Rating_CafeChateau: '« Café » du château',
    Survey_Rating_PropreteMonument: 'Propreté et entretien du monument',
    Survey_Rating_PropreteSanitaires: 'Propreté des sanitaires',
    Survey_Rating_VisiteChapelle_Chateau: 'Visite de la chapelle et du château',
    Survey_Rating_VisiteJardins: 'Visite des jardins',
    Survey_Rating_NotesEnfants: 'Qu’ont pensé vos enfants de leur visite au château ?',
    Survey_Reside_Question: 'Où résidez-vous pendant votre séjour ?',
    Survey_ResideHautesPyrenees_Question:
      'Où résidez-vous dans les Hautes-Pyrénées pendant votre séjour ?',
    Survey_ResideHauteGaronne_Question: 'Où résidez-vous en Haute-Garonne pendant votre séjour ?',
    Survey_Income_Question: 'Quel est le revenu mensuel net de votre foyer ?',
    Survey_Recommend_Question: 'Recommanderez-vous la visite du Pic du Midi ?',
    Survey_ExperienceRating_Question_CableCar: 'Le voyage en téléphérique',
    Survey_ExperienceRating_Question_Panorama: 'Le panorama',
    Survey_ExperienceRating_Question_Ponton: 'Le ponton',
    Survey_ExperienceRating_Question_Animations: 'Les animations',
    Survey_ExperienceRating_Question_EspaceExperiences: "L'espace expériences",
    Survey_ExperienceRating_Title: 'Avez-vous aimé votre expérience au Pic du Midi ?',
    Survey_Planetarium_Question: 'Avez-vous assisté à une séance de Planétarium ?',
    Survey_PlanetariumRating_Question: 'Le Planétarium',
    Survey_PlanetariumRating_Title: 'Avez-vous aimé cette séance de Planétarium ?',
    Survey_SeanceCoupole_Question: 'Avez-vous assisté à une séance de Coupole ?',
    Survey_SeanceCoupoleRating_Question: 'La Coupole',
    Survey_SeanceCoupoleRating_Title: 'Avez-vous aimé cette séance de Coupole ?',
    Survey_HearAboutSite_Question: 'Comment avez-vous entendu parler du musée ?',
    Survey_HearAboutSite_Us: 'Comment avez-vous entendu parler de nous ?',
    Survey_Origin_ZIPCode: 'Quel est votre code postal ?',
    Survey_HearAboutExhibit_Question: 'Comment avez-vous entendu parler de cette exposition ?',
    Survey_HearAboutExhibitInputField_Question:
      'Comment avez-vous entendu parler de cette exposition ?',
    Survey_VisitExhibitPrimaryReason_Question:
      "Cette exposition était-elle la principale raison de votre visite aujourd'hui ?",
    Survey_Gender_Question: 'Etes vous un homme ou une femme ?',
    Survey_GroupSize_Question: 'Combien y avait-il de visiteurs dans votre groupe ?',
    Survey_RentingPrice_Question: "Que pensez-vous du prix de location de l'HistoPad ?",
    Survey_HistopadEaseOfUse_Question: "Facilité d'utilisation de la tablette",
    Survey_HistopadContentQuality_Question: 'Qualité du contenu de la tablette',
    Survey_HistopadOverallExperience_Question: 'Expérience globale de la tablette',
    Survey_ExhibitNavigation_Question: 'Facilité de déplacement',
    Survey_ExhibitPanelContent_Question: 'Qualité du contenu des panneaux',
    Survey_ExhibitOverallExperience_Question: "Expérience globale de l'exposition",
    Survey_Rating_Boarding: 'Embarquement',
    Survey_Rating_Itinerary: 'Itinéraire proposé',
    Survey_Rating_AudioContent: 'Commentaire audio',
    Survey_Rating_InteractiveXP: 'Expériences interactives',
    Survey_VisitPrice_Question: 'Comment évaluez-vous le prix de la visite ?',
    Survey_FirstVisit_Question_Paris: 'Est-ce votre première visite à Paris ?',
    Survey_Rating_Welcome: 'Accueil',
    Survey_Rating_TipStart: 'Conseils pour la prise en main',
    Survey_Rating_ComfortVisit: 'Confort de visite',
    Survey_Rating_Orientation: 'Orientation dans le château',
    Survey_VisitPrice_Question_CastleHistoPad:
      'Comment évaluez-vous le prix de la visite ? (château + HistoPad)',
    Survey_Decide_Question: "Qu'est-ce qui va vous décider à venir?",
    Survey_Coming_Question: 'Vous êtes venu…',
    Survey_Origin_GermanLand: 'Land',
    Survey_VisitPrice_Question_Meissen: 'Comment évaluez-vous le prix de la visite ?',
    Survey_HasImprovedVisit_Question: "L'Histopad a-t-il amélioré votre visite ?",
    Survey_WillRecommend: "Recommanderiez-vous votre visite à d'autres ?",
    Survey_SaySomethingMore: 'Avez-vous une remarque supplémentaire ?',
    Survey_Rating_Signage: 'Signaletique',
    Survey_Bookstore: 'Librairie-boutique (conseil et choix)',
    Survey_HearAboutSiteInputField_Question: 'Comment avez-vous entendu parler du musée ?',
    Survey_RestaurantSaline: 'Restaurant "La table des jardins"',
    Survey_Age_Question_Categories: "À quelle tranche d'âge appartenez-vous ?",
    Survey_OtherOffers_Question:
      'Quelles autres offres utilisez-vous ? (plusieurs réponses possibles)',
    Survey_VisitPrice_QuestionVariant:
      'Quel est votre degré de satisfaction à propos du rapport qualité-prix ?',
  },
  stream_profiles: {
    title: 'Flux de commentaires',
    create: 'Créer',
    create_tooltip: 'Créer un nouveau flux de commentaires',
    name: 'Nom du profil',
    query: 'Sélection des commentaires',
    display: 'Affichage',
    sites: 'Sites',
    languages: 'Langues',
    histopad_rating: 'Note Histopad',
    visit_rating: 'Note visite',
    limit: 'Nombre de commentaires maximum',
    score_min_max: 'Score acceptable (fourchette)',
    fade_comments: 'Fade (commentaires)',
    fade_in: 'Durée du Fade (apparition)',
    fade_out: 'Durée du Fade (disparition)',
    seconds: 'secondes',
    distances: 'Distances de sécurité',
    display_duration: 'Durée des commentaires',
    min_edge: 'Rebords',
    min_comments: 'Inter-commentaires',
    min_tip: '% de la plus petite dimension',
    score: 'Score',
    score_size_ratio: 'Relation score/taille de police',
    score_size_ratio_tip: '% du score est ajouté à la taille de la police',
    rotation: 'Rotation des commentaires',
    rotation_rate: 'Temps entre chaque apparition',
    randomize_initial_direction: 'Direction initiale aléatoire',
    miscellaneous: 'Autre',
    active_comments_order: "Ordre d'appararition",
    form_active_comments_order: {
      random: 'Aléatoire',
      timeasc: 'Plus anciens en premier',
      timedesc: 'Plus récents en premier',
    },
    active_particules: 'Activer les particules (arrière-plan)',
    display_title: 'Afficher le titre',
    colors: 'Couleurs',
    background_color: 'Couleur du fond',
    font_color: 'Couleur de la police',
    secondary_color: 'Couleur secondaire',
    submit: 'Valider',
    created_profile: 'Création du nouveau profil réussi',
    update: 'Mettre à jour',
    init: 'Aucune action choisie',
    actions: 'Commandes',
    export: 'Export',
    export_code: "Code d'export",
    dimensions: "Hauteur et largeur de l'iFrame",
    iframe: 'Balise HTML iFrame',
    delete: 'Suppression',
    delete_confirmation: 'Êtes-vous sûr de vouloir supprimer le profil ',
    query_type_choice: 'Mode de sélection des commentaires',
    bookmark_selection: 'Par liste',
    filter_selection: 'Par filtre',
    launch: 'Lancer',
  },
  areas: 'Zones',
  area: 'Zone',
  maps: 'Plans',
  warnings: 'Warnings',
  maps_data: 'Je veux voir le',
  map_indicator: {
    average_visit_time: 'Temps moyen de visite :',
    visit_number: 'Nombre de visites :',
    crashs_number: 'Nombre de crashs ',
    crash: 'Nombre total de crashs sur la période ({0} - {1}) : ',
    average_time: 'Temps moyen de visite sur la période ({0} - {1}) : ',
    count: 'Nombre total de visites sur la période ({0} - {1}) : ',
    percentage: 'Nombre total de visites sur la période ({0} - {1}) : ',
    session_count: 'Nombre total de visites sur la période ({0} - {1}) : ',
    session_percentage: 'Nombre total de visites sur la période ({0} - {1}) : ',
    max_time: 'Temps moyen de visite sur la période ({0} - {1}) :',
    min_time: 'Temps moyen de visite sur la période ({0} - {1}) :',
    warning_beacon:
      "Nombre de fois où les beacons n'ont pas été détectés sur la période ({0} - {1}) : ",
  },
}
